export const ALPHABET = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const SPECIAL_FEE_SCHEDULE_NAMES = [
  'Guam',
  'Out of Network',
  'Puerto Rico',
  'Special Arrangements',
  'Virgin Islands',
];
